var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.source))]),_c('ul',_vm._l((_vm.requirementsForThisSource),function(requirement){return _c('requirement-row',{key:requirement.material.name,attrs:{"requirement":requirement}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }